import { Button, EmptyState } from "@thekrystalship/krystal";
import { AuthShell } from "./AuthChrome.jsx";

// ClusterUnavailable — the panel knows where to sign in, and cannot right now.
//
// Each fact reaching this screen is acted on differently, so they are not collapsed into one
// apology.
//
//   unreachable  the provider, or the member asked for it, did not answer. The one a person can wait
//                out, so it offers Try again
//   no_provider  a member answered and knows of no sign-in provider yet — its cluster is still
//                settling, or has nobody holding its accounts
//   ended        a session this page was using could not be renewed. Never followed on its own: the
//                panel was on screen, and leaving for the provider unasked would discard whatever
//                somebody was doing
//   refused      the provider sent the browser back without a session, naming why
//   no_access    signed in, and the cluster holds no active account for this session

const WHAT = {
  unreachable: {
    icon: "plug-zap",
    title: "Nothing answered",
    body: (c) => (c.origin
      ? <><b>{c.origin.replace(/^https?:\/\//, "")}</b> isn’t answering.</>
      : <>The cluster’s sign-in isn’t answering.</>),
  },
  no_provider: {
    icon: "unlink",
    title: "No sign-in yet",
    body: () => <>This cluster doesn’t name anywhere to sign in yet.</>,
  },
  ended: {
    icon: "log-out",
    title: "Signed out",
    body: () => <>Your session ended.</>,
  },
  refused: {
    icon: "shield-x",
    title: "Not signed in",
    body: (c) => <>The sign-in came back without a session{c.error ? <> (<code>{c.error}</code>)</> : null}.</>,
  },
  no_access: {
    icon: "user-x",
    title: "No access",
    body: () => <>You’re signed in, and this cluster has no active account for you.</>,
  },
};

function ClusterUnavailable({ state, onSignIn, onRetry, onChangeCluster, onSignOut, accountPage }) {
  const key = WHAT[state.kind] ? state.kind : "unreachable";
  const what = WHAT[key];

  return (
    <AuthShell tagline="Sign in to your control panel.">
      <EmptyState icon={what.icon} title={what.title} tone="warn"
        actions={(
          <>
            {(key === "ended" || key === "refused") && onSignIn ? (
              <Button variant="primary" size="xl" wide onClick={onSignIn}>Sign in</Button>
            ) : null}
            {(key === "unreachable" || key === "no_provider") && onRetry ? (
              <Button variant="primary" size="xl" wide onClick={onRetry}>Try again</Button>
            ) : null}
            {key === "no_access" && accountPage ? (
              <Button variant="primary" size="xl" wide href={accountPage}>Your account</Button>
            ) : null}
            {key === "no_access" && onSignOut ? (
              <Button size="xl" wide icon="log-out" onClick={onSignOut}>Sign out</Button>
            ) : null}
            {key !== "no_access" && onChangeCluster ? (
              <Button size="xl" wide icon="arrow-left" onClick={onChangeCluster}>Another address</Button>
            ) : null}
          </>
        )}>
        {what.body(state)}
      </EmptyState>
    </AuthShell>
  );
}

export { ClusterUnavailable };
